import TaskAltIcon from "@mui/icons-material/TaskAlt";
import CommonDropdownInput from "../../common/inputs/CommonDropdownInput";
import CommonFreeTextInput from "../../common/inputs/CommonFreeTextInput";
import { pointsConfig } from "../../../pointsConfig";

function PointsCreateMissionKYCCompletion({
  onKycCompletionChange,
  kycCompletion,
  data,
  setData,
}) {
  const scopeOptions = [
    { label: "Document Upload", value: "DOCUMENT_UPLOAD" },
    { label: "Requested Verification", value: "REQUEST_APPROVAL" },
    { label: "Profile Setup", value: "PROFILE_SETUP" },
    { label: "Wallet Setup", value: "WALLET_SETUP" },
  ];

  return (
    <div className="w-ful flex flex-col pb-[100px]">
      <div className="w-ful flex flex-col mb-6">
        <span className="">Scope</span>
        <small className="text-[#6D7C94]">Select all that applies</small>
        <div className="w-full gap-3 flex flex-col mt-4">
          {scopeOptions.map((option, optionIndex) => {
            const isSelected = Boolean(
              kycCompletion?.scopes?.includes(option.value)
            );
            return (
              <button
                key={optionIndex}
                className={`flex flex-1 items-center px-3 py-3 gap-3 rounded-md border-2 ${
                  isSelected
                    ? "bg-[#C4E9E3] border-[#016726]"
                    : "border-transparent bg-[#F8F8F8]"
                }`}
                onClick={() =>
                  onKycCompletionChange({ scopes: [option.value] })
                }
              >
                <div className="">
                  {isSelected ? (
                    <TaskAltIcon className="text-[#016726] text-2xl" />
                  ) : (
                    <div className="bg-[#DBDBDB] h-5 w-5 rounded-full"></div>
                  )}
                </div>
                <span className={`${isSelected ? "text-[#016726]" : ""}`}>
                  {option.label}
                </span>
              </button>
            );
          })}
        </div>
      </div>
      <CommonDropdownInput
        label="Time Frame"
        value={data?.timeFrame}
        onChange={(val) => setData({ ...data, timeFrame: val })}
        options={pointsConfig.timeFrameOptions}
      />
      <CommonFreeTextInput
        value={Number(data?.pointsRewarded).toLocaleString()}
        label="Points Rewarded"
        className="mt-4"
        onChange={(val) => {
          const numericVal = val.replace(/\D/g, "");
          setData({ ...data, pointsRewarded: numericVal });
        }}
      />
    </div>
  );
}

export default PointsCreateMissionKYCCompletion;
